import httpService from "./httpService";
import utils from "./utils";

export default {
  getAllBook(example) {
    let pageable = utils.initPageableParams({});
    return this.findAll(example, pageable);
  },
  findall() {
    return httpService.get("/book/findAll");
  },
  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("/book", {params: params});
  },

  findAllForLanhDaoVPReport(example) {
    return httpService.get("/book/findAllForLanhDaoVPReport", {params: example});
  },

  count(example) {
    return httpService.get("/book/count", {params: example});
  },
  findAllBook(config) {
    return httpService.get("/book/findAllBook", config);
  },
  add(form) {
    return httpService.post("/book", form);
  },
  edit(id, form) {
    return httpService.put(`/book/${id}`, form);
  },
  delete(id) {
    return httpService.delete(`/book/${id}`);
  },
  findById(id, config) {
    return httpService.get(`/book/${id}`, config);
  },
  findAllBookDocTypeByDocId(id, config) {
    return httpService.get(`/book/findAllBookDocTypeByDocId/${id}`, config);
  },
  changeStatus(id, form) {
    return httpService.put(`/book/${id}/changeStatus`, form);
  },
  findAllForDsvb(bookType) {
    return httpService.get("/book/findAllForDsvb",
      {
        params: {bookType: bookType}
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/bookService.js